import { observer } from "mobx-react-lite";
import { useContext } from "react";

import { CenteredLargeSpinner, Overlay } from "@bps/fluent-ui";

import { EncounterFormContext } from "./models/EncounterFormContext.ts";

export const EncounterFormSubmitOverlay = observer(() => {
  const { submitPromise } = useContext(EncounterFormContext);

  if (!submitPromise.pending) return null;

  return (
    <Overlay styles={{ root: { zIndex: 100, position: "fixed" } }}>
      <CenteredLargeSpinner />
    </Overlay>
  );
});
